import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full max-w-sm px-4" }
const _hoisted_2 = { class: "text-lg mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-red-800 font-medium" }, "Transaction Execution Error", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-700" }, "Error calling view method", -1)
const _hoisted_5 = { class: "mt-2 text-red-700 bg-gray-400 bg-opacity-10 p-2 border border-gray-300 rounded-sm font-mono whitespace-pre max-w-sm overflow-x-auto custom-scrollbar" }
const _hoisted_6 = { class: "mb-3 flex flex-wrap gap-3 justify-end items-start" }
const _hoisted_7 = {
  key: 0,
  class: "font-mono p-2 bg-gray-200 border border-gray-300 rounded-sm whitespace-pre"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_9 = { class: "flex flex-wrap gap-3 justify-end items-start" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Call")
const _hoisted_11 = { class: "gap-5 flex flex-col p-2 md:min-w-[600px]" }
const _hoisted_12 = {
  key: 0,
  class: "flex gap-3 items-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Suggested Arguments", -1)
const _hoisted_14 = { class: "flex gap-3 items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Arguments", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Specify an arguments schema.", -1)
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Add Argument", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_20 = { class: "ml-auto" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Auto-detect", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, " Scan the blockchain to find successful method calls and copy the parameter schema. ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Auto-detect might not work on every method!")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_NormalButton = _resolveComponent("NormalButton")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_SmallPrimaryButton = _resolveComponent("SmallPrimaryButton")!
  const _component_SmallTextInput = _resolveComponent("SmallTextInput")!
  const _component_Labeled = _resolveComponent("Labeled")!
  const _component_SmallSelectInput = _resolveComponent("SmallSelectInput")!
  const _component_HelpTooltip = _resolveComponent("HelpTooltip")!
  const _component_ArgumentRow = _resolveComponent("ArgumentRow")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_PendingButton = _resolveComponent("PendingButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_TransitionBob = _resolveComponent("TransitionBob")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NormalButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = true))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.methodName), 1),
        _createVNode(_component_ChevronRightIcon, {
          class: "w-5 h-5 ml-2 transition duration-150 ease-in-out group-hover:text-opacity-80",
          "aria-hidden": "true"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      open: _ctx.isModalOpen,
      title: "Call Contract",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isModalOpen = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, [
          _createElementVNode("code", null, _toDisplayString(_ctx.methodName), 1)
        ]),
        (_ctx.viewError)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              class: "bg-red-50 mb-3"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_XCircleIcon, {
                  class: "w-5 h-5 text-red-600",
                  "aria-hidden": "true"
                })
              ]),
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.viewError), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.viewResult.length > 0)
            ? (_openBlock(), _createElementBlock("output", _hoisted_7, _toDisplayString(_ctx.viewResult), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_SmallPrimaryButton, {
            class: "w-24",
            onClick: _ctx.view
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Labeled, { label: "Deposit" }, {
            default: _withCtx(() => [
              _createVNode(_component_SmallTextInput, {
                modelValue: _ctx.depositValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.depositValue) = $event)),
                theme: "light",
                class: "w-28",
                placeholder: "10e18"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Labeled, { label: "Units" }, {
            default: _withCtx(() => [
              _createVNode(_component_SmallSelectInput, {
                modelValue: _ctx.depositUnits,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.depositUnits) = $event)),
                onChange: _ctx.updateValueWithUnits,
                theme: "light",
                class: "w-32",
                options: [
              { label: 'NEAR', value: 'near' },
              { label: 'yoctoNEAR', value: 'yocto' },
            ]
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_SmallPrimaryButton, {
            class: "w-24",
            disabled: !_ctx.walletAuth.isSignedIn || !_ctx.walletAuth.isAccessible,
            onClick: _ctx.call
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.suggestedArguments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_HelpTooltip, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, "This schema conforms to " + _toDisplayString(_ctx.label) + ".", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedArguments, (arg) => {
            return (_openBlock(), _createBlock(_component_ArgumentRow, {
              key: arg.name,
              locked: "",
              active: _ctx.argModels.get(arg.name).active,
              "onUpdate:active": ($event: any) => ((_ctx.argModels.get(arg.name).active) = $event),
              field: arg.name,
              type: _ctx.argModels.get(arg.name).type,
              "onUpdate:type": ($event: any) => ((_ctx.argModels.get(arg.name).type) = $event),
              value: _ctx.argModels.get(arg.name).value,
              "onUpdate:value": ($event: any) => ((_ctx.argModels.get(arg.name).value) = $event)
            }, null, 8, ["active", "onUpdate:active", "field", "type", "onUpdate:type", "value", "onUpdate:value"]))
          }), 128)),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_HelpTooltip, null, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customArguments, (arg) => {
            return (_openBlock(), _createBlock(_component_ArgumentRow, {
              key: arg.uniqueId,
              active: arg.model.active,
              "onUpdate:active": ($event: any) => ((arg.model.active) = $event),
              field: arg.name,
              "onUpdate:field": ($event: any) => ((arg.name) = $event),
              type: arg.model.type,
              "onUpdate:type": ($event: any) => ((arg.model.type) = $event),
              value: arg.model.value,
              "onUpdate:value": ($event: any) => ((arg.model.value) = $event),
              onRemove: ($event: any) => (_ctx.removeCustomArgument(arg))
            }, null, 8, ["active", "onUpdate:active", "field", "onUpdate:field", "type", "onUpdate:type", "value", "onUpdate:value", "onRemove"]))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_PendingButton, {
              onClick: _ctx.addCustomArgument,
              class: "inline-flex items-center"
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _hoisted_19,
                _createVNode(_component_PlusIcon, { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_TransitionBob, null, {
                default: _withCtx(() => [
                  (_ctx.guessMethodUsageState === 'success')
                    ? (_openBlock(), _createBlock(_component_CheckIcon, {
                        key: 0,
                        class: "w-6 h-6 text-green-600"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_TransitionBob, null, {
                default: _withCtx(() => [
                  (_ctx.guessMethodUsageState === 'error')
                    ? (_openBlock(), _createBlock(_component_XIcon, {
                        key: 0,
                        class: "w-6 h-6 text-red-600"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_PendingButton, {
              class: "inline-flex items-center",
              onClick: _ctx.guessMethodUsage,
              mode: _ctx.guessMethodUsageState === 'pending' ? 'pending' : 'normal'
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22,
                _createVNode(_component_SearchIcon, { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["onClick", "mode"]),
            _createVNode(_component_HelpTooltip, null, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}